<template>
  <!-- надпись живёт в той же сетке 174×35, что и домик (logo_hart_estate_mark.svg):
       слои кладутся друг на друга, домик занимает левые 35 единиц, надпись начинается с 50-й.
       текст не переведён в кривые, поэтому inline svg, а не картинка — шрифт берётся со страницы,
       а textLength держит ширину надписи одинаковой при любом системном шрифте
       (122.32 — ширина, которую занимала прежняя надпись, до самого края макета) -->
  <svg
    class="brand-wordmark"
    viewBox="0 0 174 35"
    xmlns="http://www.w3.org/2000/svg">
    <text
      x="50"
      y="31.3"
      textLength="122.32"
      lengthAdjust="spacing">Hart Estate</text>
  </svg>
</template>

<style scoped>
.brand-wordmark text {
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif;
  font-size: 21px;
  font-weight: 700;
  fill: #141414;
}
</style>
